/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Axios from 'axios';
import { GetServerSideProps } from 'next';
import { getDeployedEnvType } from '@marriott/mi-apollo-client-utils';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { SESSION_APP_GET_CALL_URL, SESSION_APP_POST_CALL_URL, NEXT_PUBLIC_PREFIX } = process.env;

const NewHotels = ({ repo }) => {
  const router = useRouter();
  const SESSION_KEYS =
    'sessionToken,rewardsId,memberLevel,name,accessToken,consumerID,propertyId,AriesReservation.propertyId,AriesReservation.errorMessages,AriesCommon.prop_name,AriesCommon.memState,AriesCommon.search_destination_city,AriesCommon.search_destination_country,AriesCommon.search_destination_state,AriesCommon.search_is_weekend_stay,AriesCommon.search_brands,AriesSearch.searchCriteria,AriesSearch.search_keyword,AriesSearch.propertyFilterCriteria,AriesSearch.search_criteria_changed,AriesSearch.propertyId,AriesSearch.errorMessages';
  let loggerApiURL = '/api/logger';
  if (getDeployedEnvType() === 'higher') {
    loggerApiURL = `${repo.NEXT_PUBLIC_PREFIX}/api/logger`;
  }

  // function to get the current session ID
  const getSessionId = () => {
    const cookies = document.cookie;
    const cookieArray = cookies?.split(';');
    const sessionIdCookie = cookieArray?.find((cookie: any) => cookie?.includes('sessionID'));

    if (sessionIdCookie) {
      const sessionId = sessionIdCookie?.split('=')[1]?.trim();
      return sessionId;
    }
    return null;
  };

  // function to make get and post session call
  const fetchSessionData = async () => {
    const sessionId = getSessionId();
    const AriesUpdateSessionPayloadObject: any = {};
    const removeBlock: any = [];
    try {
      const response = await Axios.post(
        `${window.location.origin}${repo.SESSION_APP_GET_CALL_URL}`,
        {
          keys: SESSION_KEYS,
        },
        {
          headers: {
            Cookie: `sessionID=${sessionId}`,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        }
      );
      if (response) {
        const sessionDoc = response?.data;
        const AriesSearchPayloadObject = sessionDoc?.cacheData?.data?.AriesSearch;
        AriesSearchPayloadObject.hotelDirectoryFilterCriteria = {
          facets: { 'property-types': ['new'] },
          selectionOrder: [{ bucketName: 'property-types', code: 'new', label: 'new (1)' }],
        };
        AriesSearchPayloadObject.propertyFilterCriteria = {
          facets: { 'property-types': ['new'] },
        };

        AriesUpdateSessionPayloadObject['AriesSearch'] = AriesSearchPayloadObject;
        const postResponse = await Axios.post(
          `${window.location.origin}${repo.SESSION_APP_POST_CALL_URL}`,
          {
            createOrUpdate: AriesUpdateSessionPayloadObject,
            remove: removeBlock,
          },
          {
            headers: {
              Cookie: `sessionID=${sessionDoc?.sessionToken}`,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          }
        );

        if (postResponse?.status === 200) {
          router.push('/hotel-search.mi?filterApplied=true');
        }
      }
    } catch (error) {
      Axios.post(loggerApiURL, {
        message: `Error while client side rendering for session id ${sessionId}: ${JSON.stringify(error)}`,
      });
      return null;
    }
  };

  useEffect(() => {
    fetchSessionData();
  }, []);

  return (
    <div
      style={{
        height: `${toRem(600)}`,
        width: '100vw',
        position: 'absolute',
        top: '0',
        background: `${baseVariables.color['base20']}`,
      }}
    >
      <div className="m-spinner-m" style={{ position: 'absolute', top: '50%', left: '50%' }}></div>
    </div>
  );
};

export default NewHotels;

const shopSpecificData = async () => {
  return {
    SESSION_APP_GET_CALL_URL,
    SESSION_APP_POST_CALL_URL,
    NEXT_PUBLIC_PREFIX,
  };
};

export const getServerSideProps: GetServerSideProps<any> = async () => {
  const repo = await shopSpecificData();
  return { props: { repo } };
};
